import { Dispatch } from 'redux'

import { AssigneeGroupListItem, fetchAssigneeGroups } from './AssigneeGroupService'
import { queueNotification } from '~/shared/notifications/actions'
import { logger } from '~/shared/lib/logger'

export const GET_ASSIGNEE_GROUPS = 'GET_ASSIGNEE_GROUPS'
const GET_ASSIGNEE_GROUPS_ERROR = 'GET_ASSIGNEE_GROUPS_ERROR'

const getAssigneeGroupsSuccess = (assigneeGroups: AssigneeGroupListItem[]) => ({
  type: GET_ASSIGNEE_GROUPS as typeof GET_ASSIGNEE_GROUPS,
  assigneeGroups,
})

const getAssigneeGroupsError = (error: string) => ({
  type: GET_ASSIGNEE_GROUPS_ERROR as typeof GET_ASSIGNEE_GROUPS_ERROR,
  error,
})

export type AssigneeGroupAction =
  ReturnType<typeof getAssigneeGroupsSuccess> | ReturnType<typeof getAssigneeGroupsError>

export function getAssigneeGroups() {
  return async (dispatch: Dispatch) => {
    try {
      const assigneeGroups = await fetchAssigneeGroups()
      return dispatch(getAssigneeGroupsSuccess(assigneeGroups))
    } catch (e) {
      logger.error('[AssigneeGroups] fetch assignee groups', e)
      dispatch(queueNotification({ variant: 'error', message: 'Error fetching "assignee groups"' }))
      dispatch(getAssigneeGroupsError('Problem fetching assignee groups'))
      throw e
    }
  }
}
